/* eslint-disable global-require */
const { renderApplication, preRenderApplication } = require("./render");
require('../../app/assets/stylesheets/application.scss');

function enableHotReload(store) {
  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./render", () => renderApplication(store));
  }
}

function headerReducer(state = {isSidebarVisible: false, isSearchFormVisible: false}, action) {
  switch (action.type) {
    case "TOGGLE_SIDEBAR_MENU": return {...state, isSidebarVisible: !state.isSidebarVisible};
    case "OPEN_SIDEBAR_MENU": return {...state, isSidebarVisible: true};
    case "CLOSE_SIDEBAR_MENU": return {...state, isSidebarVisible: false};
    case "TOGGLE_SEARCHFORM": return {...state, isSearchFormVisible: !state.isSearchFormVisible};
    case "CLOSE_SEARCHFORM": return {...state, isSearchFormVisible: false};
    case "CLOSE_ALL": return {...state, isSidebarVisible: false, isSearchFormVisible: false};
    default: return state;
  }
}

const CUSTOM_REDUCERS = {
  header: headerReducer
};

const opts = {
  appVersion: require("../isomorphic/app-version"),
  enableServiceWorker: process.env.NODE_ENV === 'production',
  preRenderApplication,
};

if(window.OneSignal) {
  Object.assign(opts, {
    serviceWorkerLocation: '/OneSignalSDKWorker.js'
  });
}


if(global.fetch && global.Array.prototype.map && global.Promise && global.URLSearchParams && global.IntersectionObserver && global.Set) {
  const {startApp} = require('@quintype/framework/client/start');
  startApp(renderApplication, CUSTOM_REDUCERS, opts).then(enableHotReload);
} else {
  global.polyfillCallback = function() {
    const {startApp} = require('@quintype/framework/client/start');
    startApp(renderApplication, CUSTOM_REDUCERS, opts).then(enableHotReload);
  };
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = 'https://cdn.polyfill.io/v2/polyfill.min.js?features=default,IntersectionObserver,fetch&callback=polyfillCallback';
  document.getElementsByTagName('head')[0].appendChild(s);
}
